import { useState, useEffect } from 'react';
import { isApiAuthenticated, apiLogout } from '@/services/api';
import AdminLogin from './components/AdminLogin';
import AdminAliments from './components/AdminAliments';
import AdminPlats from './components/AdminPlats';



// SVG Icons
const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
);
const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
);
const LeafIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>
);
const RestaurantIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
);
const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
);
const AlertIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
);

type Tab = 'aliments' | 'plats';

export default function AdminPage() {
  const [authenticated, setAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState<Tab>('aliments');

  useEffect(() => {
    setAuthenticated(isApiAuthenticated());
  }, []);

  if (!authenticated) {
    return <AdminLogin onSuccess={() => setAuthenticated(true)} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-600 rounded-xl text-white">
                <ShieldIcon />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Interface Admin</h1>
                <p className="text-gray-500 text-xs">DT1 Simply Menu — Gestion du contenu</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => { apiLogout(); setAuthenticated(false); }}
                className="flex items-center gap-2 text-gray-500 hover:text-red-500 text-sm font-medium cursor-pointer transition-colors px-4 py-2 rounded-lg hover:bg-red-50"
              >
                <LogoutIcon />
                Déconnexion
              </button>
            </div>
          </div>

      {/* Tabs */}
          <div className="flex gap-1 mt-6 bg-gray-100 rounded-xl p-1 w-fit">
            <button
              onClick={() => setActiveTab('aliments')}
              className={`flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'aliments' ? 'bg-white text-teal-600' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <LeafIcon />
              Aliments
            </button>
            <button
              onClick={() => setActiveTab('plats')}
              className={`flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'plats' ? 'bg-white text-teal-600' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <RestaurantIcon />
              Recettes
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-8">
        <div style={{ display: activeTab === 'aliments' ? 'block' : 'none' }}>
          <AdminAliments />
        </div>
        <div style={{ display: activeTab === 'plats' ? 'block' : 'none' }}>
          <AdminPlats />
        </div>
      </div>
    </div>
  );
}
